import { Image } from "antd";
import { createUseStyles } from "react-jss";
import EmployerLayout from "../components/ui/layout/EmployerLayout";
import { UIHeading, UIText } from "../components/ui/UIElements";
import { useRouter } from "next/router";
import MainLayout from "../components/ui/layout/MainLayout";
import dynamic from "next/dynamic";

const PageNotFound = () => {
  const styles = useStyle();
  const router = useRouter();
  const pathName = router?.asPath?.includes("/employer")

  const onGoBack = () => {
    router.back();
  };
  return (
    pathName?
    <div className={styles.main}>
      <div className={styles.imgDiv}>
        <Image
          className={styles.img}
          src="https://cdn.hireside.com/cdn/images/Characters/SystemError1.svg"
          alt="Error Image"
          preview={false}
        />
      </div>

      <div className={styles.textDiv}>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
          }}
        >
          <UIHeading
            style={{
              fontWidth: 900,
              fontSize: 80,
              margin: 0,
              padding: 0,
            }}
          >
            404
          </UIHeading>
          <UIHeading
            style={{
              fontWidth: 900,
              fontSize: 45,
              margin: 0,
              padding: 0,
            }}
          >
            Page Not Found
          </UIHeading>
        </div>

        <div
          style={{
            display: "flex",
            flexDirection: "column",
            marginTop: 30,
          }}
        >
          <UIText type="secondary" level={1}>
            Sorry.. We're unable to find the page you're looking for.
          </UIText>
          <UIText style={{ marginBottom: 10 }} type="secondary" level={1}>
            Perhaps it's Because:
          </UIText>
          <UIText type="secondary" level={1}>
            - The page has moved
          </UIText>
          <UIText type="secondary" level={1}>
            - The page doesn't exist anymore
          </UIText>
        </div>
        <div onClick={onGoBack} className={styles.btn}>
          Go Back
        </div>
      </div>
    </div>

  :
    <MainLayout>
      <div className={styles.main}>
        <div className={styles.imgDiv}>
          <Image
            className={styles.img}
            src="https://cdn.hireside.com/cdn/images/Characters/SystemError1.svg"
            alt="Error Image"
            preview={false}
          />
        </div>

        <div className={styles.textDiv}>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
            }}
          >
            <UIHeading
              style={{
                fontWidth: 900,
                fontSize: 80,
                margin: 0,
                padding: 0,
              }}
            >
              404
            </UIHeading>
            <UIHeading
              style={{
                fontWidth: 900,
                fontSize: 45,
                margin: 0,
                padding: 0,
              }}
            >
              Page Not Found
            </UIHeading>
          </div>

          <div
            style={{
              display: "flex",
              flexDirection: "column",
              marginTop: 30,
            }}
          >
            <UIText type="secondary" level={1}>
              Sorry.. We're unable to find the page you're looking for.
            </UIText>
            <UIText style={{ marginBottom: 10 }} type="secondary" level={1}>
              Perhaps it's Because:
            </UIText>
            <UIText type="secondary" level={1}>
              - The page has moved
            </UIText>
            <UIText type="secondary" level={1}>
              - The page doesn't exist anymore
            </UIText>
          </div>
          <div onClick={onGoBack} className={styles.btn}>
            Go Back
          </div>
        </div>
      </div>
    </MainLayout>
  );
};

const useStyle = createUseStyles({
  main: {
    background: "#FFFFFF",
    display: "flex",
    padding: "60px 20px",
    height: "100vh",
    "@media (max-width:800px)": {
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
    },
  },
  imgDiv: {
    width: "45vw",
    display: "flex",
    alignItems: "flex-end",
    justifyContent: "center",
    flexDirection: "column",
    "@media (max-width:800px)": {
      width: "100vw",
      alignItems: "center",
    },
  },
  textDiv: {
    width: "50vw",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    padding: "30px 0px",
    paddingLeft: 70,
    "@media (max-width:800px)": {
      width: "100vw",
      padding: "30px 30px",
      marginTop: 40,
    },
  },
  img: {
    width: 500,
    "@media (max-width:1000px)": {
      width: 380,
    },
  },
  btn: {
    width: 160,
    background: "#ff9c6e",
    padding: 15,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: "white",
    fontWeight: 550,
    marginTop: 30,
    borderRadius: 10,
    cursor: "pointer",
    "&:hover": {
      background: "#ffbb96",
    },
  },
});

export default dynamic (() => Promise.resolve(PageNotFound), { ssr: false });
